module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0164.jpg?v=7a041b86";